(function() {
  function updateCountdown() {
    var now = new Date();
    var midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    var diff = midnight - now;

    if (diff <= 0) return;

    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);

    function pad(n) { return String(n).padStart(2, '0'); }

    document.querySelectorAll('[data-hj-cd="hours"]').forEach(function(el) {
      el.textContent = pad(h) + 'h';
    });
    document.querySelectorAll('[data-hj-cd="minutes"]').forEach(function(el) {
      el.textContent = pad(m) + 'm';
    });
    document.querySelectorAll('[data-hj-cd="seconds"]').forEach(function(el) {
      el.textContent = pad(s) + 's';
    });
  }

  var interval;

  function start() {
    updateCountdown();
    interval = setInterval(updateCountdown, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
